import { all, call, put, takeLatest } from 'redux-saga/effects';

import api from '../../services/api';
import {
  LIST_PLURALL_CREDENTIAL_REQUEST,
  GET_PLURALL_CREDENTIAL_REQUEST,
  ADD_PLURALL_CREDENTIAL_REQUEST,
  EDIT_PLURALL_CREDENTIAL_REQUEST,
} from '../actions';
import {
  listPlurallCredentialSuccess,
  listPlurallCredentialError,
  getPlurallCredentialSuccess,
  getPlurallCredentialError,
  addPlurallCredentialSuccess,
  addPlurallCredentialError,
  editPlurallCredentialSuccess,
  editPlurallCredentialError,
} from './actions';

function* listPlurallCredential({ payload }) {
  try {
    const { schoolId, search, searchBy } = payload;
    const params = {};

    if (search) {
      params.search = search;
    }
    if (searchBy) {
      params.search_by = searchBy;
    }

    const response = yield call(
      api.get,
      `plurall/credentials/school/${schoolId}`,
      { params }
    );
    yield put(listPlurallCredentialSuccess(response.data.data));
  } catch (error) {
    yield put(
      listPlurallCredentialError(
        error.response?.data ?? { message: 'Erro ao listar usuários Plurall.' }
      )
    );
  }
}

function* getPlurallCredential({ payload }) {
  try {
    const { id } = payload;
    const response = yield call(api.get, `plurall/credentials/${id}`);
    yield put(getPlurallCredentialSuccess(response.data.data));
  } catch (error) {
    yield put(
      getPlurallCredentialError(
        error.response?.data ?? { message: 'Erro ao carregar usuário Plurall.' }
      )
    );
  }
}

const addPlurallCredentialAsync = async (credential) =>
  api
    .post('plurall/credentials', credential)
    .then((response) => response)
    .catch((error) => error);

function* addPlurallCredential({ payload }) {
  try {
    const { credential } = payload;
    const res = yield call(addPlurallCredentialAsync, credential);

    if (!res.response) {
      yield put(addPlurallCredentialSuccess(res.data.data));
    } else {
      yield put(addPlurallCredentialError(res.response.data));
    }
  } catch (error) {
    yield put(addPlurallCredentialError(error));
  }
}

const editPlurallCredentialAsync = async (credential) =>
  api
    .put(`plurall/credentials/${credential.id}`, credential)
    .then((response) => response)
    .catch((error) => error);

function* editPlurallCredential({ payload }) {
  try {
    const { credential } = payload;
    const res = yield call(editPlurallCredentialAsync, credential);

    if (!res.response) {
      yield put(editPlurallCredentialSuccess(res.data.data));
    } else {
      yield put(editPlurallCredentialError(res.response.data));
    }
  } catch (error) {
    yield put(editPlurallCredentialError(error));
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(LIST_PLURALL_CREDENTIAL_REQUEST, listPlurallCredential),
    takeLatest(GET_PLURALL_CREDENTIAL_REQUEST, getPlurallCredential),
    takeLatest(ADD_PLURALL_CREDENTIAL_REQUEST, addPlurallCredential),
    takeLatest(EDIT_PLURALL_CREDENTIAL_REQUEST, editPlurallCredential),
  ]);
}
